import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PowerLimitationHistoryStore } from '@store';

@Component({
  selector: 'app-power-limitation-history-overlay',
  templateUrl: './power-limitation-history-overlay.component.html',
  styleUrl: './power-limitation-history-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PowerLimitationHistoryOverlayComponent implements OnInit {
  constructor(public powerLimitationHistoryStore: PowerLimitationHistoryStore) {}

  ngOnInit(): void {
    this.powerLimitationHistoryStore.loadData();
  }
}
